"use client";

import type { MutationOptions } from "@tanstack/react-query";
import { useMutation } from "@tanstack/react-query";
import gql from "graphql-tag";
import type {
  RescheduleAppointmentByCanvasIdInput,
  ScheduledCanvasAppointmentResponse,
} from "@rmh/defs";
import type { GeneratedMutation } from "@aws-amplify/api-graphql";
import { fetchGraphQLClient } from "../../../amplify/fetchGraphQLClient";

interface RescheduleAppointmentByCanvasIdVariables {
  input: RescheduleAppointmentByCanvasIdInput;
}

interface RescheduleAppointmentByCanvasIdResponse {
  data?: {
    rescheduleAppointmentByCanvasId: ScheduledCanvasAppointmentResponse;
  };
}

export const rescheduleAppointmentByCanvasIdMutation = gql`
  mutation rescheduleAppointmentByCanvasId(
    $input: RescheduleAppointmentByCanvasIdInput!
  ) {
    rescheduleAppointmentByCanvasId(input: $input) {
      success
      error {
        type
        message
        details
      }
      data {
        canvasAppointmentId
        canvasPractitionerId
        appointmentDateTime
        timestamp
      }
    }
  }
`.loc?.source.body as GeneratedMutation<
  RescheduleAppointmentByCanvasIdVariables,
  {
    rescheduleAppointmentByCanvasId: ScheduledCanvasAppointmentResponse;
  }
>;

export const useRescheduleAppointmentByCanvasId = (
  options: MutationOptions<
    RescheduleAppointmentByCanvasIdResponse,
    Error,
    RescheduleAppointmentByCanvasIdVariables
  > = {}
) => {
  const { mutateAsync, isPending } = useMutation<
    RescheduleAppointmentByCanvasIdResponse,
    Error,
    RescheduleAppointmentByCanvasIdVariables
  >({
    ...options,
    mutationFn: async (variables) =>
      fetchGraphQLClient(rescheduleAppointmentByCanvasIdMutation, variables),
  });

  const rescheduleAppointmentByCanvasId = async (
    input: RescheduleAppointmentByCanvasIdInput
  ) => {
    try {
      const response = await mutateAsync({ input });

      return response?.data?.rescheduleAppointmentByCanvasId;
    } catch (error) {
      console.error("Failed to reschedule Canvas appointment by id", error);
      throw error;
    }
  };

  return {
    rescheduleAppointmentByCanvasId,
    isPending,
  };
};
